package uz.ferro.erp.feature.visit.ui

import js.objects.jso
import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.icons.material.DownloadForOffline
import mui.material.FormControlVariant
import mui.material.Paper
import mui.material.Size
import mui.material.TextField
import mui.system.sx
import react.*
import react.dom.events.ChangeEvent
import react.dom.onChange
import react.router.useOutletContext
import uz.ferro.erp.feature.customer.data.VisitRepository
import uz.ferro.erp.feature.home.ui.DashboardUI
import uz.ferro.erp.feature.menu.model.MenuItem
import uz.ferro.erp.feature.visit.data.ExportVisitsToExcelCase
import uz.ferro.erp.feature.visit.model.VisitDto
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.ui.table.CellItem
import uz.ferro.erp.ui.table.HeaderItem
import uz.ferro.erp.ui.table.RowItem
import uz.ferro.erp.ui.table.TableView
import uz.ferro.erp.util.*
import web.cssom.*
import web.html.HTMLInputElement
import web.html.InputType
import web.url.URL

// Workaround var for wrong data state in coroutines
private var exportVisits: List<VisitDto> = emptyList()

val VisitListPage = FC {
    val dashboardUI = useOutletContext<DashboardUI>()

    // filter params
    var searchQuery by useState("")
    var date by useState(currentDateYMD())

    // data
    var visits by useState<List<VisitDto>>(emptyList())
    var filteredVisits by useState<List<VisitDto>>(emptyList())

    fun runFilter() {
        filteredVisits = visits.filter { visit ->
            val searchMatch =
            searchQuery.isBlank() ||
            visit.comment?.contains(searchQuery, ignoreCase = true) == true ||
            visit.user?.name?.contains(searchQuery, ignoreCase = true) == true ||
            visit.customer?.name?.contains(searchQuery, ignoreCase = true) == true
            searchMatch
        }
    }

    fun loadData() {
        MainScope().launch {
            try {
                visits = VisitRepository.getVisits(date)
                filteredVisits = visits
            } catch (e: Exception) {
                console.error(e)
            }
        }
    }

    fun exportToExcel() {
        MainScope().launch {
            try {
                val blob = ExportVisitsToExcelCase.exportToExcel(exportVisits)
                if (blob.size > 0) {
                    val url = URL.createObjectURL(blob)
                    val outputName = "visits_${getCurrentDateTimeSuffix()}.xlsx"

                    val a = document.createElement("a").asDynamic()
                    document.body?.appendChild(a)
                    a.style.display = "none"
                    a.href = url
                    a.download = outputName
                    a.click()
                    URL.revokeObjectURL(url)
                } else {
                    console.error("Empty blob")
                }
            } catch (e: Exception) {
                console.error(e)
            }
        }
    }

    useEffect(searchQuery) {
        runFilter()
    }

    useEffect(date) {
        loadData()
    }

    useEffect(filteredVisits) {
        exportVisits = filteredVisits
    }

    useEffectOnce {
        dashboardUI.setTitle("Tashriflar")
        dashboardUI.setMenuItems(
            page = "visit",
            items = listOf(
                MenuItem(
                    icon = DownloadForOffline,
                    title = "Export",
                    action = {
                        exportToExcel()
                    }
                )
            )
        )
    }

    useEffect(searchQuery, visits) {
        runFilter()
    }

    VerticalLayout {
        space = 16.px
        sx {
            padding = 16.px
            alignItems = AlignItems.stretch
            flexGrow = number(1.0)
        }

        HorizontalLayout {
            space = 16.px

            TextField {
                placeholder = "Qidiruv"
                size = Size.small
                value = searchQuery
                onChange = { event ->
                    event as ChangeEvent<HTMLInputElement>
                    searchQuery = event.target.value
                }
                sx {
                    paddingTop = 4.px
                    paddingBottom = 4.px
                    width = 250.px
                }
            }

            TextField {
                sx {
                    paddingTop = 4.px
                    paddingBottom = 4.px
                    width = 200.px
                }
                label = ReactNode("Sana")
                InputLabelProps = jso {
                    shrink = true
                }
                value = date
                size = Size.small
                variant = FormControlVariant.outlined
                type = InputType.date
                onChange = { event ->
                    event as ChangeEvent<HTMLInputElement>
                    date = event.target.value
                }
            }
        }

        Paper {
            sx {
                position = Position.relative
                width = 100.pct
                flexGrow = number(1.0)
                overflowY = Auto.auto
            }

            TableView {
                headers = listOf(
                    HeaderItem("ID"),
                    HeaderItem("Xodim"),
                    HeaderItem("Mijoz"),
                    HeaderItem("Izoh"),
                    HeaderItem("Tashrif vaqti"),
                    HeaderItem("Tugallangan vaqti"),
                    HeaderItem("Davomiyligi")
                )
                items = filteredVisits
                    .mapIndexed { index, visit ->
                        RowItem(
                            key = index.toString(),
                            cells = listOf(
                                CellItem(
                                    title = visit.id.toString()
                                ),
                                CellItem(
                                    title = visit.user?.name
                                ),
                                CellItem(
                                    title = visit.customer?.name
                                ),
                                CellItem(
                                    title = visit.comment
                                ),
                                CellItem(
                                    title = visit.startTime.formatHMS()
                                ),
                                CellItem(
                                    title = visit.endTime.formatHMS()
                                ),
                                CellItem(
                                    title = formatInterval(visit.startTime, visit.endTime)
                                )
                            )
                        )
                    }
            }
        }
    }
}